import * as React from 'react';

import ReactLightbox from 'react-image-lightbox';
import css from './Lightbox.module.scss';

export interface LightboxImage {
  thumbUrl: string;
  mainUrl: string;
  id: number;
}

interface Props {
  className?: string;
  images: LightboxImage[];
  alt?: string;
}
interface State {
  isOpen: boolean;
  currentPhotoIndex: number;
}

class Lightbox extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
      currentPhotoIndex: 0,
    };
  }

  public render() {
    const { isOpen, currentPhotoIndex } = this.state;
    const { alt, images } = this.props;

    if (images.length === 0) {
      return null;
    }

    const currentPhoto: LightboxImage = images[currentPhotoIndex];

    return (
      <div className={css.Lightbox}>
        <div className={css.Lightbox__List}>
          {images.map((image, i) => (
            <button
              key={image.id}
              className={css.Lightbox__Button}
              type="button"
              onClick={() =>
                this.setState({
                  isOpen: true,
                  currentPhotoIndex: i,
                })
              }
            >
              <img
                className={css.Lightbox__Thumbnail}
                src={image.thumbUrl}
                alt={alt}
              />
            </button>
          ))}
        </div>
        {isOpen && (
          <ReactLightbox
            mainSrc={currentPhoto.mainUrl}
            prevSrc={
              (images[currentPhotoIndex - 1] || images[images.length - 1])
                .mainUrl
            }
            nextSrc={(images[currentPhotoIndex + 1] || images[0]).mainUrl}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState((state, props) => {
                const prev =
                  state.currentPhotoIndex - 1 < 0
                    ? props.images.length - 1
                    : state.currentPhotoIndex - 1;
                return { currentPhotoIndex: prev };
              })
            }
            onMoveNextRequest={() =>
              this.setState((state, props) => {
                const next =
                  state.currentPhotoIndex + 1 >= props.images.length
                    ? 0
                    : state.currentPhotoIndex + 1;
                return { currentPhotoIndex: next };
              })
            }
            enableZoom={false}
          />
        )}
      </div>
    );
  }
}

export default Lightbox;
